module.exports = __webpack_public_path__ + "img/noun-empty.b8f74e39.svg";